import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { DmagPermissionService } from './dmag-permission.service';
import { DmagPopAlertService } from './dmag-popalert.service';

/**
 * Impedisce l'accesso alle route se non si hanno i permessi
 */
@Injectable()
export class PermissionGuardService implements CanActivate {
  constructor(private router: Router, private permissionService: DmagPermissionService, private popAlertService: DmagPopAlertService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const params = route.data as { permission: string | string[]; requireAll?: boolean };
    if (!params || !params.permission) {
      this.returnError();
      return false;
    }

    if (this.permissionService.isGranted(params.permission, params.requireAll)) {
      return true;
    }

    this.returnError();
    return false;
  }

  private returnError() {
    this.popAlertService.showErrorMessage('MSG.PERMISSION-ERROR');
    this.router.navigate(['./']);
  }
}
